import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Snackbar from "@material-ui/core/Snackbar";
import { Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { Button } from "../../style/Button";
import TitlDollar from "../../assets/dollar.png";
import DollarGrey from "../../assets/dollargrey.png";
import { Image2 } from "../../style/Logo";
import "./select.css";
import "../Billing/Bill.css";

const fontFamily = "work sans, 'Open Sans', Helvetica, Arial, sans-serif";

function getModalStyle() {
  // Center the modal both vertically and horizontally so the footer
  // (Send To Pharmacy) is never clipped on shorter screens. Combined
  // with paper.maxHeight below, the modal always fits the viewport
  // and scrolls internally if needed.
  return {
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  };
}

const SAVINGS_CARDS = {
  Medizen: {
    withoutCoupon: "$615",
    withCoupon: "$450*",
    epaRequired: "Yes",
    insuranceCompatible: "Yes",
    memberId: "123456789",
    bin: "008276",
    group: "A12345",
    pcn: "MED6789",
    website: "medizen.com",
  },
  Primera: {
    withoutCoupon: "$890",
    withCoupon: "$620*",
    epaRequired: "Yes",
    insuranceCompatible: "Yes",
    memberId: "987654321",
    bin: "006742",
    group: "P55678",
    pcn: "PRI1234",
    website: "primera.com",
  },
};

const renderSavingsCard = (medicationName) => {
  const data = SAVINGS_CARDS[medicationName];
  if (!data) return null;

  const wrap = {
    background: "linear-gradient(135deg, #03b3fb 0%, #4678ED 100%)",
    borderRadius: 14,
    overflow: "hidden",
    boxShadow: "0 10px 24px rgba(70, 120, 237, 0.25)",
    color: "#fff",
    display: "flex",
    alignItems: "stretch",
    fontFamily: "work sans, 'Open Sans', Helvetica, Arial, sans-serif",
    width: "100%",
  };
  const brandCol = {
    padding: "16px 22px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    borderRight: "1px solid rgba(255,255,255,0.22)",
    flexShrink: 0,
  };
  const midCol = {
    flex: 1,
    padding: "14px 22px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: 10,
  };
  const rightCol = {
    padding: "12px 16px",
    background: "rgba(21, 101, 192, 0.3)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: 8,
    flexShrink: 0,
  };
  const priceTile = {
    background: "#fff",
    borderRadius: 6,
    padding: "6px 12px",
    lineHeight: 1.1,
  };
  const pill = {
    background: "#4CAF50",
    color: "#fff",
    fontSize: 9,
    fontWeight: 700,
    padding: "3px 8px",
    borderRadius: 4,
    whiteSpace: "nowrap",
  };
  const memberLabel = { fontSize: 8, opacity: 0.75, marginBottom: 1 };
  const memberValue = { fontSize: 10, fontWeight: 700 };
  const toggle = {
    display: "flex",
    alignItems: "center",
    gap: 4,
    background: "#03b3fb",
    padding: "3px 8px",
    borderRadius: 4,
    cursor: "pointer",
  };

  return (
    <div style={wrap}>
      <div style={brandCol}>
        <div style={{ fontSize: 22, fontWeight: 700, letterSpacing: 0.3 }}>
          {medicationName}
        </div>
        <div style={{ fontSize: 10, letterSpacing: 1.5, marginTop: 2, opacity: 0.9 }}>
          SAVINGS CARD
        </div>
      </div>

      <div style={midCol}>
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
          <div style={priceTile}>
            <div style={{ fontSize: 10, color: "#666", fontWeight: 600 }}>
              Without coupon
            </div>
            <div style={{ fontSize: 16, color: "#212121", fontWeight: 700 }}>
              {data.withoutCoupon}
            </div>
          </div>
          <div style={priceTile}>
            <div style={{ fontSize: 10, color: "#2e7d32", fontWeight: 600 }}>
              With coupon
            </div>
            <div style={{ fontSize: 16, color: "#2e7d32", fontWeight: 700 }}>
              {data.withCoupon}
            </div>
          </div>
        </div>
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
          <span style={pill}>EPA Required: {data.epaRequired}</span>
          <span style={pill}>Insurance Compatible: {data.insuranceCompatible}</span>
        </div>
      </div>

      <div style={rightCol}>
        <div style={{ display: "flex", gap: 12 }}>
          <div>
            <div style={memberLabel}>Member ID</div>
            <div style={memberValue}>{data.memberId}</div>
          </div>
          <div>
            <div style={memberLabel}>BIN</div>
            <div style={memberValue}>{data.bin}</div>
          </div>
          <div>
            <div style={memberLabel}>Group</div>
            <div style={memberValue}>{data.group}</div>
          </div>
          <div>
            <div style={memberLabel}>PCN</div>
            <div style={memberValue}>{data.pcn}</div>
          </div>
        </div>
        <div style={{ display: "flex", gap: 6 }}>
          <label style={toggle}>
            <input
              type="checkbox"
              defaultChecked
              style={{ width: 10, height: 10, accentColor: "#fff", margin: 0 }}
            />
            <span style={{ fontSize: 9, fontWeight: 600 }}>Email</span>
          </label>
          <label style={toggle}>
            <input
              type="checkbox"
              defaultChecked
              style={{ width: 10, height: 10, accentColor: "#fff", margin: 0 }}
            />
            <span style={{ fontSize: 9, fontWeight: 600 }}>SMS</span>
          </label>
        </div>
        <div style={{ fontSize: 9 }}>
          Visit <span style={{ textDecoration: "underline" }}>{data.website}</span>{" "}
          to learn more
        </div>
      </div>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    width: 800,
    maxWidth: "90vw",
    maxHeight: "85vh",
    height: "auto",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #808080",
    borderRadius: 10,
    boxShadow: theme.shadows[5],
    padding: 0,
    overflow: "auto",
  },
  heading: {
    color: "#0389fb",
    fontSize: 15,
    fontFamily: "work sans",
    display: "flex",
    paddingBottom: 10,
    paddingLeft: 10,
  },
  sample: {
    backgroundColor: "#03b3fb",
    fontSize: 10,
    fontWeight: "Bold",
    paddingTop: 0,
    margin: 10,
    height: 20,
    padding: "0px",
    width: "180px",
    color: "white",
    borderRadius: 20,
    fontFamily: "work sans",
    "&:hover": {
      backgroundColor: "#0389fb",
      color: "white",
    },
  },
}));

export default function Medication({ parentCallback }) {
  const classes = useStyles();
  const [modalStyle] = React.useState(getModalStyle);
  const [open, setOpen] = React.useState(false);

  const [rowsState] = React.useState([]);
  let [medarrayState] = React.useState([]);
  const [constructorHasRun, setConstructorHasRun] = React.useState(false);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleCloseParentInfo = () => {
    setOpen(false);
    setSnackbarOpen(true);
  };

  const restoreRows = () => {
    if (constructorHasRun) return;
    let rowstring = window.sessionStorage.getItem("medarray");
    if (rowstring) {
      medarrayState = JSON.parse(rowstring);
    }
    if (medarrayState.length > 0) {
      medarrayState.forEach((element) => {
        createRows(element);
      });
    }
    setConstructorHasRun(true);
  };

  const createRows = (valuem) => {
    let discount;
    if (valuem.discount) {
      discount = (
        <React.Fragment>
          <Image2 src={TitlDollar} alt="logo" style={{marginTop:"0", marginLeft:"-40px"}} />{" "}
          <span style={{ fontWeight: 400, marginTop: "-4px", color: "green", fontFamily }}>
            Coupon/Guide Available
          </span>
        </React.Fragment>
      );
    } else {
      discount = (
        <React.Fragment>
          <Image2 src={DollarGrey} alt="logo" style={{marginTop:"0", marginLeft:"-40px"}}  />{" "}
          <span style={{ fontWeight: 500, marginTop: "-4px", color: "grey", fontFamily }}>
            NA
          </span>
        </React.Fragment>
      );
    }
    const savingsCard = renderSavingsCard(valuem.medicationName);
    rowsState.push(
      <React.Fragment>
        <Grid
          container
          spacing={0}
          style={{
            borderBottom: ".5px solid #808080",
            margin: 25,
            marginTop: -20,
            paddingBottom: 15,
          }}
        >
          <Grid item md={4} xs={12}>
            <Typography
              style={{
                padding: 7,
                fontSize: 15.52,
                fontWeight: "600",
                paddingTop: 20,
                fontFamily,
              }}
            >
              Prescriptions Sent
              <br />
              <span
                style={{
                  fontWeight: 400,
                  marginTop: 5,
                  color: "#4678ED",
                  fontFamily,
                }}
              >
                {valuem.medicationName}
              </span>
            </Typography>
          </Grid>
          <Grid item md={4} xs={12}>
            <Typography
              style={{
                padding: 7,
                fontSize: 15.52,
                fontWeight: "600",
                paddingTop: 20,
                fontFamily,
              }}
            >
              Status
              <br />
              <span style={{ fontWeight: 400, marginTop: 5, color: "green", fontFamily }}>
                Sent Successfully
              </span>
            </Typography>
          </Grid>
          <Grid item md={4} xs={12}>
            <Typography
              style={{
                padding: "20px 0 7px 37px",
                fontSize: 15.52,
                fontWeight: "600",
                fontFamily,
              }}
            >
              Coupon
              <br />
              {discount}
            </Typography>
          </Grid>
          {savingsCard && (
            <Grid
              item
              xs={12}
              style={{ marginTop: 10, marginBottom: 10, paddingRight: 25 }}
            >
              {savingsCard}
            </Grid>
          )}
        </Grid>
      </React.Fragment>
    );
  };

  restoreRows();

  const body = (
    <div style={modalStyle} className={`${classes.paper} responsivePopUp medication-confirm-modal`}>
      <Grid container spacing={0} style={{paddingBottom:"30px", fontFamily}}>
        <Grid
          item
          xs={12}
          style={{
            borderBottom: ".5px solid #d8d6d6",
            paddingTop: 20,
            paddingLeft: 36,
          }}
        >
          <Typography
            style={{
              color: "#4678ED",
              fontWeight: 600,
              marginTop: "0px",
              fontSize: "19.4px",
              marginBottom: "12px",
              fontFamily,
            }}
          >
            Prescription Confirmation{" "}
            <span
              style={{
                fontWeight: "bolder",
                color: "black",
                paddingRight: "30px",
              }}
            ></span>
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          container
          spacing={0}
          style={{
            borderBottom: ".5px solid #808080",
            margin: 25,
            marginTop: 0,
            marginBottom: 15,
            display:"block"
          }}
        >
          <Typography style={{ padding: 10, fontSize: 19.4, fontWeight: 600, fontFamily }}>
            Medication samples and coupons delivered right to your office.{" "}
            <span style={{ color: "#0389fb" }}>Free. Easy. Fast.</span>
          </Typography>

          <Typography
            style={{
              fontSize: 12.11,
              fontWeight: 400,
              paddingLeft: 10,
              marginTop: -10,
              fontFamily,
            }}
          >
            Request multiple products from a variety of suppliers, prescription
            saving cards, and get access to vouchers.
            <br /> Want to see the samples available to you? Find out now!
          </Typography>
          <Button
            className={classes.sample}
            style={{
              backgroundImage:
                "linear-gradient(315deg, #7f7f7f 0%, #9e9e9e 74%)",
              color: "white",
              fontSize: 12.11,
              padding: "5px 20px",
              height: "auto",
              width: "auto",
              fontFamily,
            }}
          >
            Learn more at sample center
          </Button>
        </Grid>
        <Grid
          container
          spacing={0}
          style={{
            borderBottom: ".5px solid #808080",
            margin: 25,
            marginTop: -10,
            marginBottom: 15,
          }}
        >
          <Grid item  md={4} xs={12}>
            <Typography
              style={{
                padding: 10,
                fontSize: 15.52,
                fontWeight: "600",
                paddingTopt: 20,
                fontFamily,
              }}
            >
              Pick Up Location
              <br />
              <p style={{ fontWeight: 15.52,fontWeight: 400, marginTop: "9px", fontFamily }}>
                Phone: 703-205-7034
                <br />
                Fax: 703-205-7035
              </p>
            </Typography>
          </Grid>
          <Grid item md={7} xs={12}>
            <Typography
              style={{
                padding: 10,
                fontSize: 15.52,
                fontWeight: "600",
                paddingLeft: 20,
                marginBottom: "12px",
                fontFamily,
              }}
            >
              VA Pharmacy 10.6MU
              <br />
              <p style={{ fontWeight: 15.52,fontWeight: 400, marginTop: "9px", fontFamily }}>
                7723 Jefferson Davis Highway
                <br />
                Arlington, VA 22201
              </p>
            </Typography>
          </Grid>
        </Grid>

        {rowsState.map((name) => name)}
        <br />
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "0 25px 10px",
          }}
        >
          <Button
            height="fit-content"
            className="billing-btn-primary billing-btn-wide"
            onClick={handleCloseParentInfo}
            style={{ float: "none", margin: 0 }}
          >
            Send To Pharmacy
          </Button>
        </Grid>
      </Grid>
    </div>
  );

  return (
    <div style={{ display: "inline-block", verticalAlign: "middle" }}>
      <Button
        height="fit-content"
        className="billing-btn-primary billing-btn-wide"
        onClick={handleOpen}
      >
        Process Medications
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {body}
      </Modal>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        message="EPA requested, task created"
        ContentProps={{
          style: {
            backgroundColor: "#03b3fb",
            color: "white",
            fontWeight: 600,
            fontFamily: "work sans, 'Open Sans', Helvetica, Arial, sans-serif",
          },
        }}
      />
    </div>
  );
}
